import { ErrorHandler } from '@frontend/error-handler';
import { SlotClient } from '@frontend/slot/api';
import { Slot } from '@frontend/slot/types';
import { useEffect, useState } from 'react';

import { SlotOpeningProps } from './slot-opening.component';

interface ViewProps {
    slot: Slot | null;
}

const useSlotOpening = (props: SlotOpeningProps): ViewProps => {
    const [slot, changeSlot] = useState<Slot | null>(null);
    useEffect(() => {
        SlotClient.resolveSlots([props.data.slot_id])
            .then((slots) => {
                if (slots.results.length > 0) {
                    changeSlot(slots.results[0]);
                }
            })
            .catch((err) => ErrorHandler.handleError({ error: err }));
    }, []);

    return { slot };
};

export default useSlotOpening;
